import React from 'react';

import ReactDOM from 'react-dom';

import { AuthProvider } from '@/core/auth/AuthContext';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';
import './axios.config';

ReactDOM.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
